<template>
    <div>
        <div class="sidebar__block sidebar_block_callback">
            <SidebarAction title="Проверить клиента"
                           description="Проверьте клиента по базе ТЕКТА на уникальность"
                           button="Проверить клиента"
                           @click.native="showUniqueCheckForm" />
        </div>

        <div v-if="linksSettings?.presentationLink"
             class="sidebar__block sidebar_block_callback">
            <SidebarAction title="Презентации проектов"
                           description="Скачать материалы по объектам"
                           button="Скачать"
                           :link="linksSettings.presentationLink"
                           is-external />
        </div>

        <div v-if="linksSettings?.regulationsLink"
             class="sidebar__block sidebar_block_callback">
            <SidebarAction title="Регламенты"
                           description="Регламенты взаимодействия и актуальные комиссии"
                           button="Скачать"
                           :link="linksSettings.regulationsLink"
                           is-external />
        </div>

        <div class="sidebar__block sidebar_block_callback">
            <SidebarAction title="Запись на брокер-тур"
                           description="Не упустите возможность лично ознакомиться с проектом"
                           button="Записаться на тур"
                           @click.native="showRequestBrokerTourForm" />
        </div>

        <div v-if="linksSettings?.telegramChannel"
             class="sidebar__block sidebar_block_callback">
            <SidebarAction title="Телеграм-канал"
                           description="Актуальные новости и предложения в нашем телеграм-канале для брокеров"
                           button="Подписаться"
                           :link="linksSettings.telegramChannel"
                           is-external />
        </div>
    </div>
</template>

<script>
import SidebarAction from '@/blocks/SidebarBlock/Action/SidebarAction';
import {mapActions, mapGetters} from 'vuex';

export default {
    components: {
        SidebarAction
    },

    computed: {
        ...mapGetters({
            linksSettings  : 'GET_LINKS_SETTINGS',
            isAuthenticated: 'GET_IS_AUTHENTICATED'
        }),
    },

    async created() {
        if (Object.keys(this.linksSettings).length === 0 && this.isAuthenticated) {
            await this.getLinksSettings();
        }
    },

    methods: {
        ...mapActions(['getLinksSettings']),

        showCallbackForm() {
            this.$emit('openCallbackPopup');
        },

        showUniqueCheckForm() {
            this.$emit('openUniqueCheckPopup');
        },

        showRequestBrokerTourForm() {
            this.$emit('openBrokerTourPopup');
        },

        toggleSidebar() {
            this.$emit('toggleSidebar');
        }
    }
};
</script>

